export interface Tile {
    groupName: string | undefined;
    iconClass: string;
    iconText: string;
    id: string;
    isSeparator: boolean;
    name: string;
    tags: string | undefined;
    dividerText?: string;
}

export interface TileDivider {
    dividerText: string;
}

export const createTileDivider = (dividerText: string): TileDivider => {
    switch (dividerText) {
        case 'Login/Logout':
            return { dividerText: 'GENERAL.TITLE.LOGIN_LOGOUT' };
        case 'Start Break':
            return { dividerText: 'GENERAL.TITLE.START_BREAK' };
        case 'End Break':
            return { dividerText: 'GENERAL.TITLE.END_BREAK' };
        case 'Break':
            return { dividerText: 'DIALOG.BREAK.TITLE' };
        case 'Recent':
            return { dividerText: 'GENERAL.TITLE.RECENT' };
        case 'All':
            return { dividerText: 'GENERAL.TITLE.ALL' };
        default:
            return { dividerText };
    }
};
